import { contactData } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
            商务通道
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            {contactData.title}
          </h2>
          <p className="text-sm text-foreground-500 mb-2">
            {contactData.subtitle}
          </p>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
            {contactData.description}
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="bg-background-50 rounded-xl p-5 border border-background-200/70">
              <div className="w-10 h-10 mx-auto rounded-xl bg-primary-100 flex items-center justify-center mb-3">
                <i className="ri-mail-line text-xl text-primary-600"></i>
              </div>
              <p className="text-xs text-foreground-400 mb-1">商务邮箱</p>
              <p className="text-sm font-semibold text-foreground-800">{contactData.email}</p>
            </div>
            <div className="bg-background-50 rounded-xl p-5 border border-background-200/70">
              <div className="w-10 h-10 mx-auto rounded-xl bg-accent-100 flex items-center justify-center mb-3">
                <i className="ri-wechat-line text-xl text-accent-600"></i>
              </div>
              <p className="text-xs text-foreground-400 mb-1">官方微信</p>
              <p className="text-sm font-semibold text-foreground-800">{contactData.wechat}</p>
            </div>
            <div className="bg-background-50 rounded-xl p-5 border border-background-200/70">
              <div className="w-10 h-10 mx-auto rounded-xl bg-secondary-100 flex items-center justify-center mb-3">
                <i className="ri-weibo-line text-xl text-secondary-600"></i>
              </div>
              <p className="text-xs text-foreground-400 mb-1">官方微博</p>
              <p className="text-sm font-semibold text-foreground-800">{contactData.weibo}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}